import { render, staticRenderFns } from "./VueTourContent.vue?vue&type=template&id=54acde7e&scoped=true"
import script from "./VueTourContent.vue?vue&type=script&lang=js"
export * from "./VueTourContent.vue?vue&type=script&lang=js"
import style0 from "./VueTourContent.vue?vue&type=style&index=0&id=54acde7e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54acde7e",
  null
  
)

export default component.exports